import { API } from 'aws-amplify';

export interface SearchInput {
    search?: string,
    internal_csn?: string,
}

export interface CompassParticipant {
    participant_id: string,
    study_id: string,
    csn: string,
    mrn: string,
    serial_number: string,
    earliest_revisit_time?: string,
    enrollment_date: string,
    end_date: string,
    last_monitor_data: string,
    last_survey_data: string,
    monitor_start: string,
    monitor_counts: string,
    survey_counts: string,
    withdrawn: string,
    monitoring: string,
}

export interface PatientVisit {
    arrival_time: string,
    csn: string,
    mrn: string,
    roomed_time: string,
    admit_time: string,
    dispo_time: string,
    departure_time: string,
    internal_csn: string,
    internal_mrn: string,
    age: number,
    gender: string,
    chief_complaint: string,
    triage_spo2: number,
    triage_rr: number,
    triage_hr: number,
    triage_temp: number,
    triage_sbp: number,
    triage_dbp: number,
    triage_acuity: string,
    ed_dispo: string,
    archived?: string,
    fhir_id?: string,
    external_id?: string,
    bed?: string,
    locations?: string[],
    encounter_types?: string[],
    admit_service?: string,
    admit_level_of_care?: string,
    granularity?: string,
    race?: string,
    ethnicity?: string,
    means_of_arrival?: string,
    diagnoses?: string[],
    payor_class?: string,
}

export interface PatientVisitMetadata {
    afib_present?: number[],
    afib_no_prev?: number[],
    afib_cha?: number[],
    afib_epi?: number,
    afib_total_sec?: number,
    epic_revisit_score?: number[],
    note?: string,
    admit_score?: number,
    total_mon?: number,
    num_priority_actions?: number,
    has_updates?: boolean,
    auto_follow?: boolean,
    manual_follow?: boolean,
    has_evaluate_capacity_output?: boolean,
    suitable_video?: string,
    video_justification?: string,
    suitable_vertical?: string,
    vertical_justification?: string,
}

export interface PatientVisitSurveyMetadata {
    survey_type?: string,
    response_count?: string,
    question_count?: string,
    survey_status?: string,
}

export const callSearchPatients = async (input: SearchInput): Promise<PatientVisit[]> => {
    try {
        const response: any = await API.post('EDPlatformFrontendAPI', '/api/search-patients', {
            body: input,
            headers: {
                'Content-Type': 'application/json',
            }
        });
        console.log('callSearchPatients response', JSON.parse(response.response));
        return JSON.parse(response.response);
    } catch (err: any) {
        console.error("An error occurred while fetching patients", err);
        return [];
    }
}
